import { Component } from '@angular/core';

@Component({
  selector: 'cms-footer',
  template: '<fin-footer></fin-footer>',
})
export class CmsFooterComponent {
  constructor() {}
}
